import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';
import { MeetingNote } from '../../types';

export const useUpdateMeetingStatus = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({
      meetingId,
      payload,
    }: {
      meetingId: number;
      payload: Partial<MeetingNote>;
    }) => {
      return await api({
        route: `/private/coach/meeting/${meetingId}`,
        token: userToken,
        method: 'PATCH',
        payload,
      });
    },

    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['hc-meeting-notes'] }),
  });

  return { mutation };
};
